<template>
  <div class="magazine-editions-client">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12 title-col">
                  <h3>{{magazine.name}}</h3>
                </div>
                <div class="col-12">
                  <span>{{magazine.description}}</span>
                </div>
              </div>
              <div class="row list-row">
                <div class="col-12">
                  <b-table :items="data" hover :fields="fields" @row-clicked="selectItemTable">
                    <template
                      v-slot:cell(year)="data"
                    >{{ `${getMonthLabel(data.item.month)} ${data.item.year} nº ${data.item.edition_number}` }}</template>
                  </b-table>
                  <div class="no-data" v-if="data.length == 0">
                    <span>Não existem edições para essa revista</span>
                  </div>
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import { bus } from "@/main";

export default {
  name: "magazine-editions-client",
  props: {
    id: Number
  },
  data() {
    return {
      perPage: 8,
      currentPage: 1,
      rows: 0,
      data: [],
      magazine: {},
      fields: [{ key: "year", label: "Edições" }],
      items: [
        {
          text: "",
          active: true
        }
      ]
    };
  },
  mounted() {
    if (!this.id) {
      let getItemParam = localStorage.getItem("params.edition_id");
      if (getItemParam) {
        this.id = getItemParam;
        localStorage.setItem("params.edition_id", null);
      } else {
        this.$router.push({ name: "Home" });
      }
    }
    bus.$emit("changeLoading", true);
    this.providerData();
    this.getDataObject(this.id);
    localStorage.setItem("params.edition_id", this.id);
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.providerData();
      }
    }
  },
  methods: {
    getDataObject: function(id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/magazines_public/${id}`)
        .then(response => {
          this.magazine = response.data;
          this.items[0].text = `Edições - ${this.magazine.name}`;
          bus.$emit("changeLoading", false);
        });
    },
    providerData() {
      axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/magazine_editions_public?${this.urlBuild()}`
        )
        .then(response => {
          this.rows = response.data.total;
          this.data = response.data.data;
          bus.$emit("changeLoading", false);
        });
    },
    urlBuild: function() {
      let url =
        "sort=-id&include=magazine&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        `&filter[magazine_id]=${this.id}`;

      return url;
    },
    selectItemTable: function(record, index) {
      this.$router.push({
        name: "public.read-edition",
        params: { id: record.id }
      });
    },
    getMonthLabel: function(value) {
      if (value == "1") return "Janeiro";
      if (value == "2") return "Fevereiro";
      if (value == "3") return "Março";
      if (value == "4") return "Abril";
      if (value == "5") return "Maio";
      if (value == "6") return "Junho";
      if (value == "7") return "Julho";
      if (value == "8") return "Agosto";
      if (value == "9") return "Setembro";
      if (value == "10") return "Outubro";
      if (value == "11") return "Novembro";
      if (value == "12") return "Dezembro";
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.magazine-editions-client {
  .title-col {
    text-align: center;
    margin-bottom: 8px;
  }
  .list-row {
    .list-title {
      margin-bottom: 8px;
      margin-top: 12px;
    }
  }
  .table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
    width: 25%;
  }
  .table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
    width: calc(100% - 25%);
  }
}
</style>